import { render, staticRenderFns } from "./VisitRegistForm.vue?vue&type=template&id=7da101d4"
import script from "./VisitRegistForm.vue?vue&type=script&lang=js"
export * from "./VisitRegistForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports